import { render } from "./LeadManagementInformation.vue?vue&type=template&id=5140146c&scoped=true"
import script from "./LeadManagementInformation.vue?vue&type=script&lang=js"
export * from "./LeadManagementInformation.vue?vue&type=script&lang=js"

import "./LeadManagementInformation.vue?vue&type=style&index=0&id=5140146c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5140146c"]])

export default __exports__